import type { ReactElement } from 'react';
import { Radar } from 'lucide-react';

export function Logo(): ReactElement {
  return (
    <div className="flex items-center gap-2.5">
      <span className="flex h-8 w-8 items-center justify-center rounded-[10px] bg-[#11131a] text-[#9ca6ff] shadow-sm dark:bg-[#ecefff] dark:text-[#3e4ee4]">
        <Radar size={18} strokeWidth={2.2} />
      </span>
      <span className="font-display text-[17px] font-semibold tracking-[-0.04em] text-ink">AI Radar</span>
    </div>
  );
}
